import React from 'react';
import Header from '../../navigation/Header';
import Footer from '../../footer/Footer';
import { ExtensionConsultationBox, extractHairExtensionsInfo} from '../HairExtensions';
import { ReadLess } from '../../../common/commonUtils';
import "../HairExtensions.css"

export default function ExtensionConsultation() {
    const info = extractHairExtensionsInfo()
    return (
        <div className='brands-container'>
            <Header/>
            <div className='mobile-view-hair-extensions'>
                <ExtensionConsultationBox
                    isDesktop={true}
                    textBody={info}
                />
                <br/>
                <ReadLess
                    page="hairExtensions"
                />
            </div>
            <Footer/>
        </div>
    )
}